import {
  GET_RTKS_REQUEST,
  GET_RTKS_SUCCESS,
  GET_RTKS_FAILURE,
  GET_RTK_REQUEST,
  GET_RTK_SUCCESS,
  GET_RTK_FAILURE,
  OPEN_RTK_MODAL,
  CLOSE_RTK_MODAL,
  SAVE_CIC_REVIEW_STATE_REQUEST,
  SAVE_CIC_REVIEW_STATE_SUCCESS,
  SAVE_CIC_REVIEW_STATE_FAILURE,
  GET_RTK_XLS_REQUEST,
  GET_RTK_XLS_ALL_SUCCESS,
  GET_RTK_XLS_FAILURE
} from 'actions';

function rtks(state = {
  isListLoading: false,
  list: null,
  listError: null,
  isRtkLoading: false,
  rtkId: null,
  isRtkModalShown: false,
  rtk: null,
  rtkError: null,
  isSavingCicReviewState: false,
  cicReviewState: null,
  cicReviewStateError: null,
  workflowState: null,
  isGettingRtkXls: false,
  userRtks: null
}, action) {
  switch (action.type) {
    case GET_RTKS_REQUEST:
      return {
        ...state,
        isListLoading: action.isListLoading,
        listError: null
      };
    case GET_RTKS_SUCCESS:
      return {
        ...state,
        isListLoading: action.isListLoading,
        list: action.list,
        listError: null
      };
    case GET_RTKS_FAILURE:
      return {
        ...state,
        isListLoading: action.isListLoading,
        list: null,
        listError: action.listError
      };
    case GET_RTK_REQUEST:
      return {
        ...state,
        isRtkLoading: action.isRtkLoading,
        rtk: null,
        cicReviewState: null,
        workflowState: null,
        rtkError: null
      };
    case GET_RTK_SUCCESS:
      return {
        ...state,
        isRtkLoading: action.isRtkLoading,
        rtk: action.rtk,
        cicReviewState: action.cicReviewState,
        workflowState: action.workflowState,
        rtkError: null
      };
    case GET_RTK_FAILURE:
      return {
        ...state,
        isRtkLoading: action.isRtkLoading,
        rtk: null,
        cicReviewState: null,
        workflowState: null,
        rtkError: action.rtkError
      };
    case OPEN_RTK_MODAL:
      return {
        ...state,
        isRtkModalShown: action.isRtkModalShown,
        rtkId: action.rtkId,
        rtk: null,
        cicReviewState: null,
        workflowState: null,
        rtkError: null
      };
    case CLOSE_RTK_MODAL:
      return {
        ...state,
        isRtkModalShown: action.isRtkModalShown,
        rtkId: null,
        rtk: null,
        cicReviewState: null,
        workflowState: null,
        rtkError: null
      };
    case SAVE_CIC_REVIEW_STATE_REQUEST:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState
      };
    case SAVE_CIC_REVIEW_STATE_SUCCESS:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState,
        cicReviewState: action.cicReviewState,
        cicReviewStateError: action.cicReviewStateError
      };
    case SAVE_CIC_REVIEW_STATE_FAILURE:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState,
        cicReviewStateError: action.cicReviewStateError
      };
    case GET_RTK_XLS_REQUEST:
      return {
        ...state,
        isGettingRtkXls: action.isGettingRtkXls
      };
    case GET_RTK_XLS_ALL_SUCCESS:
      return {
        ...state,
        isGettingRtkXls: action.isGettingRtkXls,
        userRtks: action.userRtks
      };
    case GET_RTK_XLS_FAILURE:
      return {
        ...state,
        isGettingRtkXls: action.isGettingRtkXls
      };
    default:
      return state;
  }
}

export default rtks;
